import { render } from "./SliderNews.vue?vue&type=template&id=5a09483a&ts=true&lang=pug"
import script from "./SliderNews.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderNews.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__